import { RemoteAudioTrack, RemoteParticipant, Track } from 'livekit-client';
import { useMemo } from 'react';
import { useLivekitRTCState } from '../../provider/VoiceChannel/livekit/useLivekitRTCState';
import { VoiceChannelAudioStream } from './VoiceChannelAudioStream';

type Props = {
  participant: RemoteParticipant;
};

export const VoiceChannelParticipantAudioTracks = ({ participant }: Props) => {
  const { remoteParticipants } = useLivekitRTCState();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const audioTracks = useMemo(() => {
    if (!participant) return undefined;
    const tracks: RemoteAudioTrack[] = [];

    const micTrack = participant.getTrackPublication(Track.Source.Microphone)
      ?.audioTrack as RemoteAudioTrack;

    if (micTrack) {
      tracks.push(micTrack);
    }

    if (participant.isScreenShareEnabled) {
      const screenAudio = participant.getTrackPublication(
        Track.Source.ScreenShareAudio,
      )?.audioTrack as RemoteAudioTrack;
      if (screenAudio) {
        tracks.push(screenAudio);
      }
    }

    return tracks;
  }, [
    remoteParticipants[participant?.sid],
    participant?.isMicrophoneEnabled,
    participant?.isScreenShareEnabled,
  ]);

  if (!audioTracks?.length) return null;

  return audioTracks?.map((audioTrack, index) => (
    <VoiceChannelAudioStream
      key={audioTrack.sid}
      meetId={participant.sid}
      audioTrack={audioTrack}
      index={index}
    />
  ));
};
